<template>
  <div>
    <ImageCaptureModal
      v-model:is-camera-open="isCameraOpen"
      @save-image="handleCapture($event)"
    />

    <ImageGallery
      v-if="images.length"
      :images="images"
      :capture-info="false"
      @update-images="handleDelete"
    />

    <PrimaryButton
      :label="images.length ? 'Weitere Fotos aufnehmen' : 'Kamera öffnen'"
      icon="mdi-camera-plus-outline"
      class="w-full"
      data-testid="open-camera-button"
      @click="openCamera"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ImageCaptureModal from '@/components/UI/Image/ImageCaptureModal.vue';
import ImageGallery from '@/components/UI/Image/ImageGallery.vue';
import PrimaryButton from '@/components/UI/Button/PrimaryButton.vue';
import { Image, ImageObjectType } from '@/models/Image';
import { useImageCapture } from '@/composables/useImageCapture';
import { useEntitiesStore } from '@/store/entities/entitiesStore';

const images = defineModel<Image[]>('images', { default: [] });
const objectType = defineModel<ImageObjectType>('objectType', {
  required: true,
});
const objectId = defineModel<string>('objectId', { required: true });
const isCameraOpen = ref<boolean>(false);
const entitiesStore = useEntitiesStore();

const { captureImage } = useImageCapture(objectId.value, objectType.value);

function openCamera() {
  isCameraOpen.value = true;
}

async function handleCapture(dataUrl: string) {
  const image = await captureImage(dataUrl);
  image.businessEntityId = entitiesStore.activeBusinessEntityId;
  images.value = [...images.value, image];
  isCameraOpen.value = false;
}

// Deleting already saved Images does not work
function handleDelete(index: number) {
  console.log('Deleting image at index:', index);
  images.value = images.value.filter((_, i) => i !== index);
}
</script>
